import * as Telecom from '@servicetitan/telecom-rtcs-client';
import getQueue from '../../lib/getQueue';
import log from '../../lib/log';
import refreshQueues from '../../lib/refreshQueues';

async function handleQueueAgentAdded(event: Telecom.QueueAgentAddedEvent) {
  const queue = getQueue(event.queueId);

  log('rtcs:queue:agent_added:' + queue?.name, event);

  if (!queue) {
    await refreshQueues();
    return;
  }

  queue.memberIds = [...queue.memberIds, event.agentId];
}

export default handleQueueAgentAdded;
